
define('ldsh!modules/estimate/list/template', [], function() {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<h1>Estimate</h1>\n<a class="btn btn-default" href="#/estimate/create">Create</a>\n<table class="table table-striped">\n\t<thead>\n  \n  <th>\n   poNumber\n  </th>\n  \n  <th>\n   date\n  </th>\n  \n  <th>\n   notes\n  </th>\n  \n  <th>\n   terms\n  </th>\n  \n  <th>\n   firstName\n  </th>\n  \n  <th>\n   lastName\n  </th>\n  \n  <th>\n   organization\n  </th>\n  \n  <th>\n   pStreet1\n  </th>\n  \n  <th>\n   pStreet2\n  </th>\n  \n  <th>\n   pCity\n  </th>\n  \n  <th>\n   pState\n  </th>\n  \n  <th>\n   pCountry\n  </th>\n  \n  <th>\n   pCode\n  </th>\n  \n  <th>\n   vatName\n  </th>\n  \n  <th>\n   vatNumber\n  </th>\n\n  <th>\n\n  </th>\n    <th>\n\n  </th>\n\t</thead>\n\t<tbody class="Estimate-body">\n\t</tbody>\n</table>';

}
return __p
};});

